var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('TemplateQRAction',{attrs:{"qr-code":_vm.qrCode,"detail-items":_vm.detailItems,"action-desc":_vm.$t('mnemonic_qr_action_desc'),"on-submit":_vm.onSubmit}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }